import { Navigate, Outlet } from 'react-router-dom';
import { canInspectPloomesFields } from '@v2/lib/auth';

/**
 * Gate da rota do inspetor Ploomes (permissão + fallback super_admin).
 */
export default function RequireCanInspectPloomesFields() {
    if (!canInspectPloomesFields()) {
        return <Navigate to="/forbidden" replace />;
    }

    return <Outlet />;
}
